import React, { FC, lazy, Suspense } from "react";

import { logout } from "../../../services/auth";
import { useTermsAndConditionsQuery } from "../../../hooks/api/user/useTermsAndConditionsQuery";
import { useTermsAndConditionsMutation } from "../../../hooks/api/user/useTermsAndContidionsMutation";

const TermsAndConditionsModal = lazy(() => import("./index"));

const TermsAndConditionsModalWrapper: FC = () => {
  const { data, mutate } = useTermsAndConditionsQuery();
  const { trigger: mutateTermsAndConditions } = useTermsAndConditionsMutation();

  const handleAccept = async () => {
    const response = await mutateTermsAndConditions();
    void mutate({ tcAccepted: response.tcAccepted });
  };

  if (data?.tcAccepted === false) {
    return (
      <Suspense fallback={<></>}>
        <TermsAndConditionsModal onAccept={handleAccept} onDecline={logout} />
      </Suspense>
    );
  }

  return <></>;
};

export default TermsAndConditionsModalWrapper;
